import { Vue, Component } from 'vue-property-decorator'


@Component
export class BasicMixin extends Vue {
    public dialog = false;
    public search ='';
    public edit = false;
    public snackbar = false;
    public text = '';
    public idModel = '';
}